import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerFiscalType } from "src/models/Customers/Customer.models";

interface CustomerFiscalTypeState {
  customerFiscalTypes: ICustomerFiscalType[];
  customerFiscalTypeToEdit: ICustomerFiscalType | null;
}

const initialState: CustomerFiscalTypeState = {
  customerFiscalTypes: [],
  customerFiscalTypeToEdit: null,
};

const customerGroupSlice = createSlice({
  name: "CustomerFiscalType",
  initialState,
  reducers: {
    setCustomerFiscalTypeList: (
      state,
      action: PayloadAction<ICustomerFiscalType[]>
    ) => {
      state.customerFiscalTypes = action.payload;
    },
    concatListCustomerFiscalType: (
      state: CustomerFiscalTypeState,
      action: PayloadAction<ICustomerFiscalType[]>
    ) => {
      state.customerFiscalTypes = [
        ...state.customerFiscalTypes.concat(action.payload),
      ];
    },
    setCustomerFiscalTypeToEdit: (
      state,
      action: PayloadAction<ICustomerFiscalType | null>
    ) => {
      state.customerFiscalTypeToEdit = action.payload;
    },
    addCustomerFiscalType: (
      state,
      action: PayloadAction<ICustomerFiscalType>
    ) => {
      state.customerFiscalTypes.push(action.payload);
    },
    updateCustomerFiscalType: (
      state,
      action: PayloadAction<ICustomerFiscalType>
    ) => {
      let itemIndex = state.customerFiscalTypes.findIndex(
        item => item.fiscalTypeId === action.payload.fiscalTypeId
      );
      if (itemIndex !== -1)
        state.customerFiscalTypes[itemIndex] = action.payload;
    },
    deleteCustomerFiscalType: (state, action: PayloadAction<number>) => {
      const newArray = state.customerFiscalTypes.filter(
        item => item.fiscalTypeId !== action.payload
      );
      state.customerFiscalTypes = newArray;
    },
  },
});

export const {
  setCustomerFiscalTypeList,
  concatListCustomerFiscalType,
  setCustomerFiscalTypeToEdit,
  addCustomerFiscalType,
  updateCustomerFiscalType,
  deleteCustomerFiscalType,
} = customerGroupSlice.actions;

export default customerGroupSlice.reducer;
